<template>
  <div class="chat-input-container">
    <div v-if="reply && reply.message" class="reply-message-container">
      <div class="reply-message-content">
        <p v-if="reply.message.type === 'text'">Respondendo a: {{ reply.message.text }} - {{
          moment(reply.dateMessage).format('HH:mm') }}</p>
        <p v-else-if="reply.message.type === 'audio'">Respondendo a: Áudio - {{
          moment(reply.dateMessage).format('HH:mm') }}</p>
        <p v-else-if="reply.message.type === 'image'">Respondendo a: Imagem - {{
          moment(reply.dateMessage).format('HH:mm') }}</p>
        <p v-else-if="reply.message.type === 'document'">Respondendo a: Documento - {{
          moment(reply.dateMessage).format('HH:mm') }}</p>
        <p v-else-if="reply.message.type === 'video'">Respondendo a: Vídeo - {{
          moment(reply.dateMessage).format('HH:mm') }}</p>
        <p v-else>Respondendo a: {{ reply.message.type }} - {{ moment(reply.dateMessage).format('HH:mm') }}</p>
        <button @click="cancelReply" class="cancel-reply-button">Cancelar</button>
      </div>
    </div>
    <div class="px-3">
      <div v-if="provider === 'whats_meta' && timeLeft > 0 && lastMessageSender === 'User'" class="timer">
        Tempo restante: {{ formattedTimeLeft }}
      </div>
      <div v-if="provider === 'whats_meta' && timeLeft === 0 && lastMessageSender === 'User'" class="expired-message">
        Tempo de atendimento expirado, finalize a conversa.
      </div>
      <div v-if="provider === 'whats_meta' && lastMessageSender !== 'User'" class="expired-message">
        Atendimento sem resposta.
      </div>
    </div>
    <div v-if="timeLeft > 0 || provider !== 'whats_meta'" class="chat-input-message-box">
      <b-input-group class="chat-input-group">
        <b-input-group-prepend is-text>
          <span class="chat-input-options" @click="openAttachModalArquivo">
            <i class="fas fa-paperclip" />
          </span>
        </b-input-group-prepend>
        <b-input-group-prepend is-text v-if="enableAudioAtendimento">
          <span class="chat-input-options" @click="openAttachModalAudio">
            <i class="fas fa-microphone" />
          </span>
        </b-input-group-prepend>
        <b-form-textarea v-model="message" placeholder="Digite sua mensagem" rows="2" max-rows="8" no-resize
          :disabled="disabled" @keydown.shift.enter.prevent="handleShiftEnterKey"
          @keydown.enter.prevent.stop="handleEnterKey" />
        <b-input-group-append is-text>
          <span class="chat-input-options">
            <i class="fas fa-arrow-right" :class="{ 'selected': !isEmptyMessage() }" @click="sendMessage" />
          </span>
        </b-input-group-append>
      </b-input-group>
    </div>
    <AudioModal :reply="reply" ref="audioModal" @sendAudio="sendAudio" />
    <FileModal :reply="reply" ref="fileModal" @sendFile="sendArchive" @sendAudio="sendArchive" />
  </div>
</template>

<script>
import _ from 'lodash'
import AudioModal from '../modal/AudioModal.vue'
import FileModal from '../modal/FileModal.vue'
import EnvironmentRepository from '@/shared/http/repositories/access/environment'

export default {
  name: 'ChatInput',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    reply: {
      type: Object,
      required: false
    },
    lastMessageDate: {
      type: String,
      required: false,
      default: null
    },
    lastMessageSender: {
      type: String,
      required: false,
      default: null
    },
    lastMessage: {
      type: String,
      required: false,
      default: null
    },
    provider: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      message: '',
      showModal: false,
      botSelected: '',
      bots: [],
      timeLeft: 0,
      timerInterval: null,
      enableAudioAtendimento: false
    }
  },
  mounted () {
    EnvironmentRepository.getEnv()
      .then(response => {
        this.enableAudioAtendimento = response.data.enableAudioAtendimento
      })
      .catch(() => {
        console.error('enableAudioAtendimento')
      })
  },
  computed: {
    recordingButtonText () {
      return this.isRecording ? 'Parar Gravação' : 'Iniciar Gravação'
    },
    formattedTimeLeft () {
      const hours = Math.floor(this.timeLeft / 3600)
      const minutes = Math.floor((this.timeLeft % 3600) / 60)
      const seconds = this.timeLeft % 60
      return `${hours}h ${minutes}m ${seconds}s`
    }
  },
  watch: {
    files: {
      handler (newFiles) { },
      deep: true
    },
    reply (newVal, oldVal) {
      console.log('Reply prop changed:', newVal)
    },
    disabled (value) {
      if (value) {
        this.message = ''
      }
    },
    lastMessageDate: {
      handler (newDate) {
        if (newDate && this.provider === 'whats_meta' && this.lastMessageSender === 'User') {
          this.startTimer(newDate)
        }
      },
      immediate: true
    },
    lastMessageSender: {
      handler (newSender) {
        if (this.provider === 'whats_meta' && newSender !== 'Bot') {
          this.startTimer(this.lastMessageDate)
        }
      },
      immediate: true
    },
    provider: {
      handler (newProvider) {
        if (newProvider !== 'whats_meta') {
          this.stopTimer()
        } else if (this.lastMessageSender !== 'Bot') {
          this.startTimer(this.lastMessageDate)
        }
      },
      immediate: true
    }
  },
  components: {
    AudioModal,
    FileModal
  },
  methods: {
    handleShiftEnterKey (event) {
      if (event.keyCode === 13 && event.shiftKey) {
        event.preventDefault()
        this.message += '\n'
      }
    },
    handleEnterKey (event) {
      event.preventDefault()
      if (event.keyCode === 13 && !event.shiftKey) {
        this.sendMessage()
      }
    },
    isEmptyMessage () {
      let message = this.message
      if (_.isNil(message) || !_.isString(message)) return true
      message = _.trimEnd(message)
      return _.isEmpty(message)
    },
    sendMessage () {
      if (this.isEmptyMessage()) return
      const message = {
        text: this.message,
        type: 'text',
        quotedMsg: this.getQuotedMsg()
      }
      this.$emit('sendMessage', message)
      this.$nextTick(() => {
        this.message = ''
      })
    },
    sendArchive (archive) {
      this.$emit('sendArchive', archive)
    },
    sendImage (image) {
      this.$emit('sendImage', image)
    },
    sendAudio (audio) {
      this.$emit('sendArchive', audio)
    },
    sendBot () {
      if (this.botSelected === '' || this.botSelected === null) {
        this.$bvToast.toast('Selecione um bot para ativar', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
        return
      }
      this.showModalBot = false
      const botInfo = {
        botId: this.botSelected
      }
      this.$emit('sendControllerBot', botInfo)
      this.sendUpdateOperator()
    },
    sendUpdateOperator () {
      const message = {
        username: null,
        nameOperator: 'BOT',
        event: 'transferir',
        description: 'Ativando o bot ' + this.botSelected
      }
      this.$emit('sendUpdateOperator', message)
    },
    cancelReply () {
      this.$emit('cancelReply')
    },
    onChange () {
      this.files.push(...this.$refs.file.files)
    },
    dragover (e) {
      e.preventDefault()
      this.isDragging = true
    },
    dragleave () {
      this.isDragging = false
    },
    drop (e) {
      e.preventDefault()
      this.$refs.file.files = e.dataTransfer.files
      this.onChange()
      this.isDragging = false
    },
    openAttachModalArquivo () {
      this.$refs.fileModal.show()
    },
    openAttachModalAudio () {
      this.$refs.audioModal.show()
    },
    generateURL (file) {
      let fileSrc = URL.createObjectURL(file)
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc)
      }, 1000)
      return fileSrc
    },
    remove (index) {
      this.files.splice(index, 1)
    },
    getQuotedMsg () {
      if (this.reply && this.reply.message) {
        return this.reply.message.messageId
      }
      return null
    },
    startTimer (dateMessage) {
      if (this.provider !== 'whats_meta') return

      const messageTime = new Date(dateMessage).getTime()
      const currentTime = Date.now()
      const timeElapsed = Math.floor((currentTime - messageTime) / 1000)
      this.timeLeft = 86400 - timeElapsed

      if (this.timerInterval) {
        clearInterval(this.timerInterval)
      }

      this.timerInterval = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--
        } else {
          clearInterval(this.timerInterval)
          this.timeLeft = 0
        }
      }, 1000)
    },
    stopTimer () {
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
        this.timeLeft = 0
      }
    },
    getInputText () {
      return this.message
    },
    setInputText (text) {
      this.message = text
    }
  },
  beforeDestroy () {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
    }
  }
}
</script>

<style scoped>
.chat-input-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f1f1f1;
  border-bottom-left-radius: 0.35rem;
  border-bottom-right-radius: 0.35rem;
}

.reply-message-container {
  background-color: #e0f7fa;
  padding: 10px;
  border: 1px solid #b2ebf2;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 10px;
}

.reply-message-content {
  display: flex;
  align-items: center;
  max-width: 40ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cancel-reply-button {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-size: 14px;
  position: absolute;
  right: 10px;
}

.chat-input-options {
  display: flex;
  gap: 7px;
  margin-right: 1.0rem;
  margin-bottom: 0.25rem;
  font-size: 18px;
  color: #AAB2BD;
  cursor: pointer;
}

.chat-input-message-box {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}

.chat-input-group .input-group-text {
  background-color: #fff;
}

.chat-input-group textarea {
  border-left: none;
  border-right: none;
}

.timer {
  font-size: 12px;
  color: gray;
  margin-top: 10px;
}

.expired-message {
  font-size: 18px;
  color: gray;
  text-align: center;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/chat/ChatInput.vue